import React from 'react';
import { CustomError } from "./CustomError";

export const CustomCheckbox = ({ schema, uiSchema, formData, onChange }) => {
  const { href, hrefText, title } = schema;

  return (
    <div className={"checkbox custom-field"}>
      <label>
        <input
          type="checkbox"
          checked={formData}
          onChange={() => onChange(!formData)}
        />
        <div>
          <span>{title}</span>
          {(href && hrefText) && <a target="_blank" rel="noreferrer" href={href}>{hrefText}</a>}
        </div>
      </label>
      <CustomError schema={schema} uiSchema={uiSchema} />
    </div>
  );
}
